import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ionic-perfect-iap',
  template: `
    <p>
      ionic-perfect-iap works!
    </p>
  `,
  styles: [
  ]
})
export class IonicPerfectIapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
